import script from "./ViewDetailsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDetailsButton.vue?vue&type=script&setup=true&lang=ts"

import "./ViewDetailsButton.vue?vue&type=style&index=0&id=591d45ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591d45ed"]])

export default __exports__